import React from 'react'
import { If } from '@components/tsx-statements'
import Footers from 'components/Footers'
import { getApproval, getIsApproved } from 'components/QuoteTOS/utils'
import {
  GABARIT_PADDING_MEDIUM,
  GABARIT_PADDING_SMALL
} from 'constants/theme'
import withConnect from './connector'
import {
  VALIDATION_BUTTON_HEIGHT,
  VALIDATION_INFO_HEIGHTS,
  VALIDATION_TOS_HEIGHT,
  Wrapper
} from './style'
import {
  GetMobilePaddingBottom,
  MapStateToProps as Props
} from './types'

const getMobilePaddingBottom: GetMobilePaddingBottom = ({
  hasActivePackage,
  hasEstimatedPrice,
  hasPackages,
  isPackagesPage,
  isPaymentBannerDisplayable,
  isProductPage,
  isQuoteTOSFeatureEnabled,
  isSelectionPage,
  screenSize
}) => {
  if (screenSize.large) return

  const hasPackagePagePaddingBottom = (isPackagesPage && hasActivePackage) || isSelectionPage
  const hasProductPagePaddingBottom = !isPackagesPage && !isSelectionPage && isProductPage
  const isDeepLinkProduct = !hasPackages

  const gabaritPadding = screenSize.medium ? GABARIT_PADDING_MEDIUM : GABARIT_PADDING_SMALL
  let amountOfInfoDisplayedAboveButton = 0

  if (hasProductPagePaddingBottom) {
    if (isDeepLinkProduct && isPaymentBannerDisplayable) { amountOfInfoDisplayedAboveButton += 1 }

    return VALIDATION_BUTTON_HEIGHT + gabaritPadding * 2 + VALIDATION_INFO_HEIGHTS[amountOfInfoDisplayedAboveButton]
  }

  if (hasPackagePagePaddingBottom) {
    if (isPaymentBannerDisplayable) { amountOfInfoDisplayedAboveButton += 1 }
    if (hasEstimatedPrice) { amountOfInfoDisplayedAboveButton += 1 }
    const quoteTOSHeight = isQuoteTOSFeatureEnabled && !getIsApproved(getApproval()) ? VALIDATION_TOS_HEIGHT : 0

    return VALIDATION_BUTTON_HEIGHT + gabaritPadding * 2 + VALIDATION_INFO_HEIGHTS[amountOfInfoDisplayedAboveButton] + quoteTOSHeight
  }
}

const Footer: React.FC<Props> = ({
  hasActivePackage,
  hasEstimatedPrice,
  hasPackages,
  isPackagesPage,
  isPaymentBannerDisplayable,
  isProductPage,
  isQuoteTOSFeatureEnabled,
  isSaleHomePage,
  isSelectionPage,
  screenSize
}) => (
  <If condition={!isSaleHomePage}>
    <Wrapper
      paddingBottom={getMobilePaddingBottom({
        hasActivePackage,
        hasEstimatedPrice,
        hasPackages,
        isPackagesPage,
        isPaymentBannerDisplayable,
        isProductPage,
        isQuoteTOSFeatureEnabled,
        isSelectionPage,
        screenSize
      })}
    >
      <If condition={!isPackagesPage && !isSelectionPage}>
        <Footers />
      </If>
    </Wrapper>
  </If>
)

export default withConnect(Footer)
